import { NavLink, useNavigate } from "react-router-dom";
import { Trophy, House, ChatCircleText, User, Gear, SignOut, UsersThree, BookOpen } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "@/components/Avatar";

const navItems = [
  { to: "/", label: "Home", icon: House, testid: "nav-home" },
  { to: "/pokerians", label: "Pokerians", icon: UsersThree, testid: "nav-pokerians" },
  { to: "/chat", label: "Chat", icon: ChatCircleText, testid: "nav-chat" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
  { to: "/rules", label: "Rules", icon: BookOpen, testid: "nav-rules" },
];

export function AppShell({ children }) {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const items = [...navItems];
  if (isAdmin) items.push({ to: "/admin", label: "Admin", icon: Gear, testid: "nav-admin" });

  return (
    <div className="min-h-screen grain relative">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-black/80 backdrop-blur-xl border-b border-white/10" style={{ paddingTop: "env(safe-area-inset-top)" }}>
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 group"
            data-testid="header-logo"
          >
            <Trophy size={28} weight="fill" className="text-primary" />
            <span className="font-heading font-black text-2xl tracking-tighter uppercase">Vegas 2027</span>
          </button>
          <div className="flex items-center gap-3">
            {user && (
              <button
                onClick={() => navigate("/profile")}
                className="flex items-center gap-2"
                data-testid="header-profile"
              >
                <span className="hidden sm:block text-sm font-semibold text-muted-foreground">
                  {user.nickname || user.name}
                </span>
                <Avatar name={user.nickname || user.name} path={user.avatar_path} size={36} />
              </button>
            )}
            <button
              onClick={logout}
              className="p-2 text-muted-foreground hover:text-kinetic transition-colors"
              title="Log out"
              data-testid="logout-button"
            >
              <SignOut size={22} weight="bold" />
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 pb-28 pt-6 relative z-10">{children}</main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 left-0 right-0 z-30 bg-black/90 backdrop-blur-xl border-t border-white/10" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="max-w-5xl mx-auto flex items-stretch justify-around">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex-1 flex flex-col items-center gap-1 py-3 transition-colors ${
                    isActive ? "text-primary" : "text-muted-foreground hover:text-white"
                  }`
                }
              >
                <Icon size={24} weight="bold" />
                <span className="text-[10px] font-bold uppercase tracking-widest">{it.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
